/* @flow */

export const ALL_TOPICS = 'ALL_TOPICS';
export const USER_TOPICS = 'USER_TOPICS';
export const USER_RELATED_TOPICS = 'USER_RELATED_TOPICS';
export const OWN_TOPICS = 'OWN_TOPICS';
export const OWN_ACTIVE_TOPICS = 'OWN_ACTIVE_TOPICS';
export const OWN_HIDDEN_TOPICS = 'OWN_HIDDEN_TOPICS';
export const OWN_PENDING_TOPICS = 'OWN_PENDING_TOPICS';
export const OWN_REJECTED_TOPICS = 'OWN_REJECTED_TOPICS';
export const USERS_TOPICS = 'USERS_TOPICS';
export const USERS_ACTIVE_TOPICS = 'USER_ACTIVE_TOPICS';
